import { ROUTES } from 'shared/const/routes';
import { ApiResponse, IntlFormatMessageFunc } from 'shared/model/types';

export const combineClasses = (...classNames: (string | undefined | false)[]) => {
  return classNames.filter(Boolean).join(' ');
};
export const getRouteByKey = (key: string) => {
  for (const routeKey in ROUTES) {
    if (ROUTES[routeKey as keyof typeof ROUTES].key === key) {
      return ROUTES[routeKey as keyof typeof ROUTES];
    }
  }
  return undefined;
};

function componentToHex(c: number): string {
  const hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

function rgbToHex(r: number, g: number, b: number): string {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export const colorToHex = (color: string): string | null => {
  if (color.startsWith('#')) {
    // Цвет уже в HEX
    return color;
  } else if (color.startsWith('rgb')) {
    // Преобразование RGB(A) в HEX
    const components = color
      .replace(/rgba?\(([^)]+)\)/, '$1')
      .split(',')
      .map((component) => component.trim());
    // Убираем альфа-канал, если он есть, и преобразуем в числа
    const [r, g, b] = components.slice(0, 3).map(Number);
    return rgbToHex(r, g, b);
  } else {
    // Для именованных цветов и HSL(A) здесь может быть дополнительная логика преобразования
    console.error('Unsupported color format:', color);
    return null;
  }
};

export const getGreyColor = (opacity: number = 0.05) => {
  return `rgba(0, 0, 0, ${opacity})`;
};

export const getLinearGradientString = (
  gradient: string[],
  angle: number = 135,
): string => {
  return `linear-gradient(${angle}.00deg, ${gradient[0]} 0%,${gradient[1]} 100%)`;
};

export const getErrorDefaultMessage = (
  response: ApiResponse<unknown>,
): string | undefined => {
  if (response?.errors?.[0]) {
    if (response.errors[0].field === 'system') {
      return undefined;
    }
    return response.errors[0]?.defaultMessage;
  }
  return undefined;
};

export const handleErrorWithCommonFallback = (response: ApiResponse<unknown>, t: IntlFormatMessageFunc, showError: (message: string) => unknown) => {
  if (response) {
    showError(
      getErrorDefaultMessage(response) || t({ id: 'common.message.error' }),
    );
  } else {
    showError(t({ id: 'common.message.error' }));
  }
}

export const splitBalance = (balance: number | undefined) => {
  const balanceFixed =
    balance !== undefined && isFinite(balance) ? balance.toFixed(2) : '0.00';
  const balanceString = balanceFixed.replace('.', ',');
  return balanceString.split(',');
};

export const getOSInformation = () => {
  const userAgent = navigator.userAgent;
  let browser;
  let browserVersion;
  const os = navigator.platform;

  if (userAgent.includes('Firefox/')) {
    browser = 'Firefox';
    browserVersion = `v${userAgent.split('Firefox/')[1]}`;
  } else if (userAgent.includes('Edg/')) {
    browser = 'Edg';
    browserVersion = `v${userAgent.split('Edg/')[1]}`;
  } else if (userAgent.includes('Chrome/')) {
    browser = 'Chrome';
    browserVersion = `v${userAgent.split('Chrome/')[1]}`;
  } else if (userAgent.includes('Safari/')) {
    browser = 'Safari';
    browserVersion = `v${userAgent.split('Safari/')[1]}`;
  }

  return {
    os,
    browser,
    browser_version: browserVersion,
  };
};

export const convertBytesToMb = (bytes: number) => bytes / 1024 ** 2;